module.exports = __webpack_public_path__ + "static/media/Cindy Lau.0d370040.png";